export const useOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "url": "https://vehis.pl",
  "logo": "https://vehis.pl/favicon-32x32.png",
  "name": "VEHIS",
  "description": "Leasing samochodów z atrakcyjnymi warunkami finansowania u lidera w branży ✔️ Decyzja w 15 min. Sprawdź!",
  "email": "twojdoradca@vehis.pl",
  "telephone": "+48 22 104 92 05",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "al. Murckowska 14c",
    "addressLocality": "Katowice",
    "addressCountry": "PL",
    "addressRegion": "Śląskie",
    "postalCode": "40-265"
  },
  "vatID": "PL1132995753",
  "iso6523Code": "9930:1132995753"
})

export const useBreadcrumbsStructuredData = (items) => ({
	"@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url || undefined,
  }))
})